import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { Card, FlexItem, ListItem, Text } from 'components/Library'

const RecentPages = () => {
  const { paginas } = useSelector((state) => state.pages)
  const [datosGrafico, setDatosGrafico] = useState([])

  useEffect(() => {
    const paginasRecientes = paginas.slice(0, 3)
    setDatosGrafico(paginasRecientes)
  }, [paginas])

  return (
    <Card style={{ padding: '2rem', width: '100%' }}>
      <Text weight="bold">Páginas creadas recientemente</Text>
      {datosGrafico.map((pagina, index) => (
        <ListItem
          key={index}
          style={{
            display: 'flex',
            gridGap: '1rem',
            paddingTop: '1rem'
          }}
        >
          <span
            style={{
              color: 'white',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              borderRadius: '2rem',
              width: '40px',
              height: '40px'
            }}
          >
            <img
              style={{
                borderRadius: '2rem',
                width: '40px',
                height: '40px'
              }}
              src="/logo.png"
              alt={pagina?.opciones?.ES?.titulo}
            />
          </span>
          <FlexItem
            alignItems="center"
            flexDirection="row"
            style={{
              padding: '0',
              flex: 'auto'
            }}
          >
            <FlexItem
              flexDirection="column"
              style={{
                padding: 0,
                placeItems: 'flex-start'
              }}
            >
              <Text weight="bold">{pagina?.opciones?.ES?.titulo}</Text>
              <Text color="#5e5e5e" size="small">
                {pagina.url && `${window.location.host}/${pagina.url}`}
              </Text>
            </FlexItem>
            <Text size="small">{dayjs(pagina?.fechaCreacion).format('DD MMM YYYY')}</Text>
          </FlexItem>
        </ListItem>
      ))}
    </Card>
  )
}

export default RecentPages
